var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactFormTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 769,
    height: 1537,
    viewBox: "0 0 769 1537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M769 1537V0L0 768.5 769 1537",
    fill: "url(#contact-form-triangle_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "contact-form-triangle_svg__paint0_linear",
    x1: 769,
    y1: 1537,
    x2: 0,
    y2: 1537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C1DE"
  })))));
}

export default SvgContactFormTriangle;